module.exports = __webpack_public_path__ + "fonts/Sen-Bold.b2142d66.woff2";